import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddUserAuth } from "../store/actions/userAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_CONFIG } from "../share/common";
const axios = require("axios");

function Register({ setUserControlShow }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const register = async (e) => {
    e.preventDefault();
    const {
      firstname,
      lastname,
      email,
      username,
      password,
      address,
      phone,
    } = e.target;
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_API_URL + "/register",
        {
          firstName: firstname.value,
          lastName: lastname.value,
          email: email.value,
          userName: username.value,
          password: password.value,
          address: address.value,
          phone: phone.value,
          admin: false,
        }
       
      );
      
      toast.info(`😀 Bienvenido ${data.firstName.toUpperCase()}!`, TOAST_CONFIG);
      dispatch(AddUserAuth(data));
      setUserControlShow(false);
      history.push("/");
    } catch (error) {
      toast.error(error.response.data.error, TOAST_CONFIG);
    }
  };

  return (
    <form onSubmit={register}>
      <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
        Nombre
      </label>
      <input
        required
        name="firstname"
        type="text"
        className="form-control"
        placeholder="John"
        id="inputFirstName"
      />
      <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
        Apellido
      </label>
      <input
        required
        name="lastname"
        type="text"
        className="form-control"
        placeholder="Doe"
        id="inputLastName"
      />
      <label for="inputEmail" className="fw-bold fs-6 mt-3 mb-2">
        Email
      </label>
      <input
        required
        type="email"
        name="email"
        className="form-control"
        placeholder="example@mail.com"
        id="inputEmail"
        pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
      />
      <label for="inputUsername" className="fw-bold fs-6 mt-3 mb-2">
        Nombre de usuario
      </label>
      <input
        required
        name="username"
        type="text"
        className="form-control"
        placeholder="username"
        id="inputUsername"
        pattern="^[a-zA-Z0-9.\-_$@*!]{3,30}$"
      />

      <label for="inputaddress" className="fw-bold fs-6 mt-3 mb-2">
        Dirección
      </label>
      <input
        required
        name="address"
        type="text"
        className="form-control"
        id="address"
      />

      <label for="inputphone" className="fw-bold fs-6 mt-3 mb-2">
        Teléfono
      </label>
      <input
        required
        name="phone"
        type="number"
        className="form-control"
        id="inputphone"
      />

      <label for="inputPassword" className="fw-bold fs-6 mt-3 mb-2">
        Contraseña
      </label>
      <input
        required
        name="password"
        type="password"
        className="form-control"
        placeholder="password"
        id="inputPassword"
        pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
      />
       <p className="mt-1">Debe contener al menos una letra mayúscula, una letra minúscula y un número</p>

      <button
        type="submit"
        id="signup-button"
        className="btn btn-dark rounded-pill d-block w-100 mt-3"
      >
        Entrar
      </button>
    </form>
  );
}

export default Register;
